export const selectUser = (state) => state.user.user?.signInUserSession?.idToken?.payload;
